/* Mapper from the grading-classifier's milestone-shaped result to the
 * Comcast-shape CBPersonaSignals that drives the roleplay UI.
 *
 * Lossy by design — the live classifier returns extra fields
 * (`objection_label`, `yield_quality`) that the grading library reads
 * separately when it materializes the verdict. Those don't ride the
 * onPersonaSignals channel today; if a future feature needs them on
 * the live gauge UI, extend ClassifyTurnResult to carry them.
 *
 * Mock cardinality: ≥0 milestones per turn (regex detector can match
 * multiple rules). Live cardinality: ≤1 milestone per turn (OpenAI
 * returns one classification). We take the first match either way —
 * the UI's MetaCueChip only has room for one and the gauge sums the
 * temperature delta independently. */

import type { CBPersonaSignals } from '@/lib/codebaby';
import type { ClassifyTurnResult } from '@/lib/grading/classifier';

export function classificationToSignals(result: ClassifyTurnResult): CBPersonaSignals {
  const first = result.milestones[0];
  return {
    temperature_delta: result.temperatureDelta,
    milestone_tag: first?.tag ?? null,
    objection_raised: null,
    objection_handled: null,
    close_offered: false,
    close_size: null,
    is_key_moment: first?.isKeyMoment ?? false,
    moment_type: first?.momentType ?? null,
    moment_summary: first?.notes ?? null,
  };
}
